import React                 from 'react';
import {
  useDispatch,
  useSelector
}                            from "react-redux";
import useGetBrowseFrame     from "../../../hooks/useGetBrowseFrame";
import {
  getEndTimeSimple,
  getStartTime
}                            from "../../../hooks/useGettimelineForPane";
import { ApplicationState }  from "../../../store";
import { successBrowsePane } from "../../../store/browse/actions";
import { BrowseState }       from "../../../store/browse/types";
import { LayoutState }       from "../../../store/layouts/types";
import { getTimeline }       from "../../../store/timeline/actions";
import { TimelineState }     from "../../../store/timeline/types";
import {
  errorPaneTime,
  successPaneTime
}                            from "../../../utils";
import ImagePaneComponent    from "../../reusable/ImagePaneComponent";
import PaneTimeComponent     from "../../reusable/PaneTimeComponent/PaneTimeComponent";
import SpinnerComponent      from "../../reusable/SpinnerComponent";
import ZoomComponent         from "../../reusable/ZoomComponent";
import './style.css';

interface Props {
  pane: number
}

const BrowsemodePaneComponent: React.FC<Props> = ({pane}) => {
  const dispatch = useDispatch();
  const {checkedPane} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const {browsePanes} = useSelector<ApplicationState, BrowseState>(state => state.browse);
  const {time} = useSelector<ApplicationState, TimelineState>(state => state.timeline);

  const error = browsePanes?.[pane]?.error;
  const success = browsePanes?.[pane]?.success;
  const fetch = browsePanes?.[pane]?.fetch;
  const inited = browsePanes?.[pane]?.inited;

  const src = useGetBrowseFrame(pane, time);

  const getTimelineOnload = () => {
    if (pane === 0 || pane === 1) {
      const startTime = getStartTime(time);
      const endTime = getEndTimeSimple(time);
      const continuationId = browsePanes?.[pane]?.continuation_id ? browsePanes[pane].continuation_id : null;

      dispatch(getTimeline(pane, startTime, endTime, continuationId));
    }
  }

  const onImageLoad = () => {
    dispatch(successBrowsePane(pane));

    getTimelineOnload();

    successPaneTime(pane);
  };
  const onImageError = () => {
    dispatch(successBrowsePane(pane));

    getTimelineOnload();

    errorPaneTime(pane)
  };

  return (
    <>
      {
        !success && <div className='pos-abs w-100 h-100 flex al-it-c js-c'>
          {(fetch || inited || error) && <SpinnerComponent/>}
        </div>
      }
      <ZoomComponent enable={checkedPane === pane && src !== ''}
                     pane={pane}
      >
        <div className='w-100 h-100 flex al-it-c js-c'>
          {
            (src) &&
            <>
              <ImagePaneComponent src={src ? src : ''}
                                  pane={pane}
                                  alt={'thumbnail-' + pane}
                                  className={'thumbnail-pane'}
                                  time={time}
                                  onload={onImageLoad}
                                  onerror={onImageError}
              />
              <PaneTimeComponent pane={pane}
                                 time={time}
              />
            </>
          }
        </div>
      </ZoomComponent>
    </>
  )
};


export default BrowsemodePaneComponent